import axios from "axios";
import { APPCONSTANT } from "../Constants/AppConstant.js";
import Environment from "../Helper/APIParam.js";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";

import { EVN } from "../Helper/APIParam.js";
import network, { Method } from "./../NetworkManager/NetworkManager.js";
import app from "./App.js";

class SetSDK {
	async config(
		init = { domain, env, custom_header, pk_key, domain_details }
	) {
		try {
			if (
				init?.pk_key &&
				init?.domain_details &&
				init?.domain_details?.tenant_name
			) {
				APPCONSTANT.TOKEN = init.pk_key;
				APPCONSTANT.DOMAIN_ID =
					init.domain_details?.id ?? 0;
				APPCONSTANT.ENVIRONMENT = init.env;
				APPCONSTANT.DOMAIN = init.domain;
				APPCONSTANT.CUSTOM_HEADER = init.custom_header
					? init.custom_header
					: {};
				return {
					status: true,
					key: init?.pk_key,
					domain_details: init?.domain_details,
					tenant_name:
						init?.domain_details?.tenant_name ??
						"",
				};
			} else {
				const response = await axios({
					url: `${
						init.env.startsWith("dev")
							? "https://api.dev.tradly.app"
							: "https://api.tradly.app"
					}/skua/tenants/pk_by_domain?domain=${
						init.domain
					}&env=${init.env}`,
					method: "GET",
					responseType: "json",
					headers: {
						"Content-Type": "application/json",
					},
				});
				if (response.data.status) {
					APPCONSTANT.TOKEN = response.data.data.key;
					APPCONSTANT.DOMAIN_ID =
						response.data.data.domain?.id ?? 0;
					APPCONSTANT.ENVIRONMENT = init.env;
					APPCONSTANT.DOMAIN = init.domain;
					APPCONSTANT.CUSTOM_HEADER =
						init.custom_header
							? init.custom_header
							: {};
					return {
						status: true,
						key: response.data.data.key,
						domain_details: {
							...response.data.data.domain,
							tenant_name:
								response.data.data
									.tenant_name ??
								"",
						},
						tenant_name:
							response.data.data
								.tenant_name ?? "",
					};
				}
			}
		} catch (error) {
			return error;
		}
	}
}
const set_sdk = new SetSDK();
export default set_sdk;
